import { defineMessages } from 'react-intl';

export default defineMessages({
  next: {
    id: 'app.containers.TurnReportEdit.next',
    defaultMessage: 'Next',
  },
  handInReport: {
    id: 'app.containers.TurnReportEdit.handInReport',
    defaultMessage: 'Hand in report',
  },
  closeReport: {
    id: 'app.containers.TurnReportEdit.closeReport',
    defaultMessage: 'Close report',
  },
  attendees: {
    id: 'app.containers.TurnReportEdit.attendees',
    defaultMessage: 'Present publishers',
  },
  status: {
    id: 'app.containers.TurnReportEdit.status',
    defaultMessage: 'Status',
  },
  statusOpen: {
    id: 'app.containers.TurnReportEdit.statusOpen',
    defaultMessage: 'Open',
  },
  statusClosed: {
    id: 'app.containers.TurnReportEdit.statusClosed',
    defaultMessage: 'Closed',
  },
});
